import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import formattingRulesParameters from '@atlassian/jira-relay/src/__generated__/formatRulesQuery$parameters';
import parameters from '@atlassian/jira-relay/src/__generated__/src_jiraSoftwareListQuery$parameters';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const FORMAT_RULES_FIRST = 20;

export const listEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-software-list-entrypoint" */ './src'),
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (projectKey == null) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				listQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectKey,
					},
				},
				formattingRulesQuery: {
					parameters: formattingRulesParameters,
					variables: {
						projectKey,
						cloudId,
						first: FORMAT_RULES_FIRST,
					},
					options: {
						fetchPolicy: 'network-only' as const,
					},
				},
			},
		};
	},
});
